/* tslint:disable */
/* eslint-disable */
/**
 * ElisTech API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.0
 * Contact: info@ideatech.cz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiV1AccountWebLogoutPost200Response } from '../models';
// @ts-ignore
import type { ApiV1NotificationRegisterTokenPostRequest } from '../models';
// @ts-ignore
import type { ApiV1NotificationRemoveTokenPostRequest } from '../models';
/**
 * NotificationApi - axios parameter creator
 */
export const NotificationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Register FCM token for push notifications
         * @param {ApiV1NotificationRegisterTokenPostRequest} [apiV1NotificationRegisterTokenPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NotificationRegisterTokenPost: async (apiV1NotificationRegisterTokenPostRequest?: ApiV1NotificationRegisterTokenPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/notification/register-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1NotificationRegisterTokenPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register FCM token for push notifications
         * @param {ApiV1NotificationRegisterTokenPostRequest} [apiV1NotificationRegisterTokenPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NotificationRegisterTokenPost_1: async (apiV1NotificationRegisterTokenPostRequest?: ApiV1NotificationRegisterTokenPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/notification/register-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1NotificationRegisterTokenPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove FCM token
         * @param {ApiV1NotificationRemoveTokenPostRequest} [apiV1NotificationRemoveTokenPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NotificationRemoveTokenPost: async (apiV1NotificationRemoveTokenPostRequest?: ApiV1NotificationRemoveTokenPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/notification/remove-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1NotificationRemoveTokenPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove FCM token
         * @param {ApiV1NotificationRemoveTokenPostRequest} [apiV1NotificationRemoveTokenPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NotificationRemoveTokenPost_2: async (apiV1NotificationRemoveTokenPostRequest?: ApiV1NotificationRemoveTokenPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/notification/remove-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1NotificationRemoveTokenPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationApi - functional programming interface
 */
export const NotificationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Register FCM token for push notifications
         * @param {ApiV1NotificationRegisterTokenPostRequest} [apiV1NotificationRegisterTokenPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1NotificationRegisterTokenPost(apiV1NotificationRegisterTokenPostRequest?: ApiV1NotificationRegisterTokenPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1AccountWebLogoutPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1NotificationRegisterTokenPost(apiV1NotificationRegisterTokenPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.apiV1NotificationRegisterTokenPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Register FCM token for push notifications
         * @param {ApiV1NotificationRegisterTokenPostRequest} [apiV1NotificationRegisterTokenPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1NotificationRegisterTokenPost_1(apiV1NotificationRegisterTokenPostRequest?: ApiV1NotificationRegisterTokenPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1AccountWebLogoutPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1NotificationRegisterTokenPost_1(apiV1NotificationRegisterTokenPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.apiV1NotificationRegisterTokenPost_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove FCM token
         * @param {ApiV1NotificationRemoveTokenPostRequest} [apiV1NotificationRemoveTokenPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1NotificationRemoveTokenPost(apiV1NotificationRemoveTokenPostRequest?: ApiV1NotificationRemoveTokenPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1AccountWebLogoutPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1NotificationRemoveTokenPost(apiV1NotificationRemoveTokenPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.apiV1NotificationRemoveTokenPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove FCM token
         * @param {ApiV1NotificationRemoveTokenPostRequest} [apiV1NotificationRemoveTokenPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1NotificationRemoveTokenPost_2(apiV1NotificationRemoveTokenPostRequest?: ApiV1NotificationRemoveTokenPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1AccountWebLogoutPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1NotificationRemoveTokenPost_2(apiV1NotificationRemoveTokenPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.apiV1NotificationRemoveTokenPost_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationApi - factory interface
 */
export const NotificationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationApiFp(configuration)
    return {
        /**
         * 
         * @summary Register FCM token for push notifications
         * @param {ApiV1NotificationRegisterTokenPostRequest} [apiV1NotificationRegisterTokenPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NotificationRegisterTokenPost(apiV1NotificationRegisterTokenPostRequest?: ApiV1NotificationRegisterTokenPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1AccountWebLogoutPost200Response> {
            return localVarFp.apiV1NotificationRegisterTokenPost(apiV1NotificationRegisterTokenPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register FCM token for push notifications
         * @param {ApiV1NotificationRegisterTokenPostRequest} [apiV1NotificationRegisterTokenPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NotificationRegisterTokenPost_1(apiV1NotificationRegisterTokenPostRequest?: ApiV1NotificationRegisterTokenPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1AccountWebLogoutPost200Response> {
            return localVarFp.apiV1NotificationRegisterTokenPost_1(apiV1NotificationRegisterTokenPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove FCM token
         * @param {ApiV1NotificationRemoveTokenPostRequest} [apiV1NotificationRemoveTokenPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NotificationRemoveTokenPost(apiV1NotificationRemoveTokenPostRequest?: ApiV1NotificationRemoveTokenPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1AccountWebLogoutPost200Response> {
            return localVarFp.apiV1NotificationRemoveTokenPost(apiV1NotificationRemoveTokenPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove FCM token
         * @param {ApiV1NotificationRemoveTokenPostRequest} [apiV1NotificationRemoveTokenPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NotificationRemoveTokenPost_2(apiV1NotificationRemoveTokenPostRequest?: ApiV1NotificationRemoveTokenPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1AccountWebLogoutPost200Response> {
            return localVarFp.apiV1NotificationRemoveTokenPost_2(apiV1NotificationRemoveTokenPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationApi - object-oriented interface
 */
export class NotificationApi extends BaseAPI {
    /**
     * 
     * @summary Register FCM token for push notifications
     * @param {ApiV1NotificationRegisterTokenPostRequest} [apiV1NotificationRegisterTokenPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1NotificationRegisterTokenPost(apiV1NotificationRegisterTokenPostRequest?: ApiV1NotificationRegisterTokenPostRequest, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).apiV1NotificationRegisterTokenPost(apiV1NotificationRegisterTokenPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register FCM token for push notifications
     * @param {ApiV1NotificationRegisterTokenPostRequest} [apiV1NotificationRegisterTokenPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1NotificationRegisterTokenPost_1(apiV1NotificationRegisterTokenPostRequest?: ApiV1NotificationRegisterTokenPostRequest, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).apiV1NotificationRegisterTokenPost_1(apiV1NotificationRegisterTokenPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove FCM token
     * @param {ApiV1NotificationRemoveTokenPostRequest} [apiV1NotificationRemoveTokenPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1NotificationRemoveTokenPost(apiV1NotificationRemoveTokenPostRequest?: ApiV1NotificationRemoveTokenPostRequest, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).apiV1NotificationRemoveTokenPost(apiV1NotificationRemoveTokenPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove FCM token
     * @param {ApiV1NotificationRemoveTokenPostRequest} [apiV1NotificationRemoveTokenPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1NotificationRemoveTokenPost_2(apiV1NotificationRemoveTokenPostRequest?: ApiV1NotificationRemoveTokenPostRequest, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).apiV1NotificationRemoveTokenPost_2(apiV1NotificationRemoveTokenPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

